<template>
  <el-container class="chat-page" :class="{ 'mobile-chat-mode': isMobileChatMode }">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller class="scroll-box" :items="showConversations">
        <template v-slot="{ item }">
          <chat-item :conversation="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)"
            @info="onShowInfo(item)" @dnd="onDnd(item)" @top="onTop(item)" :active="item === activeConv"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-area">
      <div class="mobile-back-btn el-icon-back" v-if="isMobile" @click="onBackToList"></div>
      <chat-box v-if="activeConv" :conversation="activeConv"></chat-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      isMobile: window.innerWidth <= 768, // H5/窄屏标识
      mobileChatOpened: false // 窄屏下是否进入聊天视图（否则显示会话列表）
    }
  },
  methods: {
    onActiveItem(conv) {
      this.chatStore.setActive(conv.key);
      // 窄屏下点会话进入聊天视图
      this.mobileChatOpened = true;
    },
    onBackToList() {
      // 窄屏下返回会话列表（会话仍保持选中）
      this.mobileChatOpened = false;
    },
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    onDelItem(conv) {
      const tip = `删除后记录将清空,确认删除与'${conv.showName}'的聊天 ?`;
      this.$confirm(tip, '删除聊天', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.isPrivate(conv) || this.isGroup(conv)) {
          const data = { chatId: conv.targetId }
          const chatTypeText = this.isPrivate(conv) ? "private" : "group";
          await this.$http({
            url: `/message/${chatTypeText}/deleteChat`,
            method: 'delete',
            data: data
          });
        }
        await this.chatStore.remove(conv.key);
      });
    },
    onShowInfo(conv) {
      if (this.isPrivate(conv)) {
        this.$router.push("/home/friend?id=" + conv.targetId);
      } else if (this.isGroup(conv)) {
        if (!this.groupStore.isGroup(conv.targetId)) {
          this.$message.error("您已不在群聊中")
          return;
        }
        this.$router.push("/home/group?id=" + conv.targetId);
      }
    },
    onTop(conv) {
      this.chatStore.setTop(conv.key, !conv.isTop)
    },
    onDnd(conv) {
      if (this.isPrivate(conv)) {
        this.setFriendDnd(conv, conv.targetId, !conv.isDnd)
      } else {
        this.setGroupDnd(conv, conv.targetId, !conv.isDnd)
      }
    },
    setFriendDnd(conv, friendId, isDnd) {
      const formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })
    },
    setGroupDnd(conv, groupId, isDnd) {
      const formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })
    },
    isShow(conv) {
      return !this.searchText || conv.showName.includes(this.searchText)
    },
    isPrivate(conv) {
      return this.$enums.CONVERSATION_TYPE.PRIVATE == conv.type
    },
    isGroup(conv) {
      return this.$enums.CONVERSATION_TYPE.GROUP == conv.type
    },
  },
  computed: {
    activeConv() {
      return this.chatStore.activeConversation;
    },
    loading() {
      return this.chatStore.loading;
    },
    showConversations() {
      return this.chatStore.conversations.filter(conv => this.isShow(conv));
    },
    // 窄屏且已点开某个会话时，切换到聊天视图（隐藏会话列表）
    isMobileChatMode() {
      return this.isMobile && this.mobileChatOpened && !!this.activeConv;
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
}
</script>

<style lang="scss" scoped>
.chat-page {

  .header {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 8px;
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }
  }

  .chat-items {
    flex: 1;
  }

  .chat-area {
    position: relative;
    min-width: 0;

    // 窄屏下显示的返回按钮（回到会话列表），默认隐藏
    .mobile-back-btn {
      display: none;
    }
  }

}

// H5/窄屏适配：会话列表与聊天区二选一展示，避免两侧挤压
@media screen and (max-width: 768px) {
  .chat-page {
    .resizable-aside {
      width: 100% !important; // 覆盖组件内联的固定像素宽度
      max-width: 100%;

      :deep(.resize-handle) {
        display: none; // 窄屏禁用拖拽调宽
      }
    }

    .chat-area {
      display: none;
    }

    &.mobile-chat-mode {
      .resizable-aside {
        display: none;
      }

      .chat-area {
        display: flex;

        .mobile-back-btn {
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          width: 44px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 22px;
          color: var(--im-text-color);
          cursor: pointer;
          z-index: 100;
        }

        // 标题右移，避免被返回按钮遮挡
        :deep(.chat-box .el-header) {
          padding-left: 48px;
        }
      }
    }
  }
}
</style>

<!-- 非 scoped 块：ChatMessageItem.vue / ChatInput.vue 的样式无 scoped（全局），需用 .chat-page 前缀在窄屏下覆盖（与 H5Chat 页保持一致） -->
<style lang="scss">
@media screen and (max-width: 768px) {
  .chat-page {
    // 输入区高度（桌面端 220px 偏高）
    .im-chat-footer {
      height: 160px !important;
    }

    // 回到底部提示随输入区高度下移
    .locate-tip {
      bottom: 170px;
    }

    // 工具栏精简：隐藏文件传输、群回执、音视频通话等
    .chat-tool-bar>div[title="发送文件"],
    .chat-tool-bar>div[title="回执消息"],
    .chat-tool-bar>div[title="语音通话"],
    .chat-tool-bar>div[title="多人通话"],
    .chat-tool-bar>div[title="视频通话"] {
      display: none !important;
    }

    // 收窄消息气泡两侧 padding（桌面端 300px/180px 在窄屏会把气泡挤没）
    .chat-message-item {

      .message-normal:not(.message-mine) .content .message-bottom {
        padding-right: 24% !important;
      }

      .message-normal.message-mine .content .message-bottom {
        padding-left: 24% !important;
      }

      // 长按消息时禁用系统的文字选择/呼出菜单
      .message-bottom {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        user-select: none;
      }
    }

    // iOS 下 contenteditable 字号 <16px 会自动缩放页面
    [contenteditable="true"] {
      font-size: 16px !important;
    }
  }
}
</style>
